import styled from "styled-components/macro";

import useStaxAPI from "Payments/AddPaymentMethod/CreditCardEntry/useStaxAPI";

import FnrButton, { FnrButtonContent } from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";
import { colors } from "UI/colors";

export default function SelectPaymentMethodPopover({
  show,
  setShow,
  buttonRef,
  onCardSelect,
  onACHSelect,
}) {
  // initializes stax if it is required
  useStaxAPI();

  return (
    <>
      <FnrPopover
        show={show}
        buttonRef={buttonRef}
        onShouldClose={() => setShow(false)}
      >
        <Content>
          <Title>What type of payment method would you like to add?</Title>
          <ButtonsWrapper>
            {/* <Button onClick={onACHSelect}>
              <ButtonInside className="pmButtonInside">
                <Icon className="far fa-university" />
                <Text>Bank Account</Text>
              </ButtonInside>
            </Button>
            <Button onClick={onCardSelect}>
              <ButtonInside className="pmButtonInside">
                <Icon className="far fa-credit-card" />
                <Text>Credit or Debit Card</Text>
              </ButtonInside>
            </Button> */}
            <FnrButton onClick={onACHSelect} color="blue">
              <FnrButtonContent>
                <div>
                  <Icon className="far fa-university" />
                  <Label>Bank Account</Label>
                </div>
              </FnrButtonContent>
            </FnrButton>
            <FnrButton onClick={onCardSelect} color="blue">
              <FnrButtonContent>
                <div>
                  <Icon className="far fa-credit-card" />
                  <Label>Credit or Debit Card</Label>
                </div>
              </FnrButtonContent>
            </FnrButton>
          </ButtonsWrapper>
        </Content>
      </FnrPopover>
    </>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 10px;
  //   max-width: 260px;

  max-width: 330px;
`;

const Title = styled.div`
  text-transform: uppercase;
  text-align: center;
  text-shadow: rgb(0 0 0 / 20%) 1px 1px 2px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  gap: 30px;

  button {
    min-width: 150px;
  }
`;

const Button = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  //border: 1px solid ${colors.fnDkBlue};
  border-radius: 12px;
  width: 45%;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  color: ${colors.fnDkBlue};
  box-shadow: 0 0 8px rgb(0 0 0 / 20%);

  transition: all 250ms linear;

  &:hover {
    background: ${colors.fnLtGray};
    //background-image: linear-gradient(135deg, #98a4a5 0%, #a5b0b3 100%);
  }

  &:hover .pmButtonInside {
    transform: scale(1.05);
  }
`;

const ButtonInside = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;

  transition: transform 250ms ease-in-out;

  &:active {
    transform: scale(0.95) !important;
  }
`;

const Icon = styled.div`
  //   font-size: 42px;

  text-align: center;
  font-size: 32px;
`;

const Label = styled.div`
  //   text-align: center;

  margin-top: 8px;
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.2;
  text-transform: uppercase;
`;
